/* FLYVIA theme behaviours */
(function () {
  "use strict";

  // Sticky header style on scroll
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-stuck", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // Mobile menu drawer
  var menu = document.querySelector("[data-mobile-menu]");
  var openBtn = document.querySelector("[data-menu-open]");
  var closeEls = document.querySelectorAll("[data-menu-close]");
  var setMenu = function (open) {
    if (!menu) return;
    menu.classList.toggle("open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if (openBtn) openBtn.setAttribute("aria-expanded", open ? "true" : "false");
  };
  if (openBtn) openBtn.addEventListener("click", function () { setMenu(true); });
  closeEls.forEach(function (el) { el.addEventListener("click", function () { setMenu(false); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") setMenu(false); });

  // Legal centre tab switching
  var legalLinks = document.querySelectorAll("[data-legal-tab]");
  if (legalLinks.length) {
    var showSection = function (id) {
      document.querySelectorAll("[data-legal-section]").forEach(function (s) {
        s.classList.toggle("active", s.getAttribute("data-legal-section") === id);
      });
      legalLinks.forEach(function (l) {
        l.classList.toggle("active", l.getAttribute("data-legal-tab") === id);
      });
      if (history.replaceState) history.replaceState(null, "", "#" + id);
    };
    legalLinks.forEach(function (l) {
      l.addEventListener("click", function (e) {
        e.preventDefault();
        showSection(l.getAttribute("data-legal-tab"));
      });
    });
    var hash = window.location.hash.replace("#", "");
    if (hash && document.querySelector('[data-legal-section="' + hash + '"]')) showSection(hash);
  }

  // Sync the homepage "Travel Type" hidden helper (Flights vs Holiday) into the enquiry form
  // and keep the date "Return" field disabled for one-way trips.
  var tripInputs = document.querySelectorAll('[data-trip-type] input[type="radio"]');
  var returnField = document.querySelector("[data-return-field] input");
  if (tripInputs.length && returnField) {
    tripInputs.forEach(function (r) {
      r.addEventListener("change", function () {
        var oneWay = r.value === "One-way" && r.checked;
        returnField.disabled = oneWay;
        returnField.closest("[data-return-field]").style.opacity = oneWay ? ".45" : "1";
      });
    });
  }
})();

/* Intro preloader: fade out when video ends (or after a safety timeout) */
(function(){
  var pre = document.getElementById('flyvia-preloader');
  if(!pre) return;
  if(getComputedStyle(pre).display === 'none'){ return; } // already shown this session
  var once = pre.getAttribute('data-once') === 'true';
  document.body.classList.add('preloader-active');
  var vid = pre.querySelector('video');
  var done = false;
  function finish(){
    if(done) return; done = true;
    pre.classList.add('hide');
    document.body.classList.remove('preloader-active');
    try{ if(once) sessionStorage.setItem('flyvia_preloader_shown','1'); }catch(e){}
    setTimeout(function(){ if(pre && pre.parentNode){ pre.parentNode.removeChild(pre); } }, 650);
  }
  if(vid){
    vid.addEventListener('ended', finish);
    var pp = vid.play();
    if(pp && pp.catch){ pp.catch(function(){ /* autoplay blocked: still hide shortly */ }); }
  }
  setTimeout(finish, 6000); // safety: never block the page longer than ~6s
})();
